
import Vue from 'vue'
import axios from 'axios'
import * as Sentry from '@sentry/vue'
import Component from 'vue-class-component'

import { Job } from '@/domains/global/models'
import JobCreateForm from '../components/JobCreate/JobCreateForm.vue'
import { consumeError } from '@/domains/global/utils'

@Component({
  components: { JobCreateForm }
})
export default class JobCreatePage extends Vue {
  isLoading = false

  isSubmitting = false

  async submit(job: Job) {
    this.isLoading = true
    const data = {
      type: 'agency',
      customerGivenName: job.customerGivenName,
      customerSurname: job.customerSurname,
      customerEmail: job.customerEmail,
      directAssign: job.directAssign,
      languageId: job.languageId,
      postageRequired: job.postageRequired,
      profileId: job.profileId
    }

    this.isSubmitting = true
    try {
      const result = await axios.post<Job>('/jobs', data)
      if (result.data && result.data.id) {
        this.$router.push({ path: `${result.data.id}/activities/new` })
      }
    } catch (error) {
      const formattedError = consumeError(error as any)
      if (formattedError.code !== 'SENTRY') {
        this.$store.dispatch('error', formattedError.message)
      } else {
        Sentry.captureException(error)
      }
    } finally {
      this.isSubmitting = false
      this.isLoading = false
    }
  }
}
